import { getAdEnum, getAdConfig } from '@/pages/advertise/api'
import { requestDataLoadingHelper } from '@/utils/request/helper'


// 获取广告枚举
export async function getEnum({ state, commit }, params) {  
  try {
    const res = await requestDataLoadingHelper(getAdEnum, {
      ...params,
    })
    commit('updateEnumConf', res)
  } catch (error) {
    console.log(error)
  }
}

// 获取广告配置
export async function getConfig({ state, commit }, params) {
  try {
    const res = await requestDataLoadingHelper(getAdConfig, {
      ...params,
    })
    commit('updateAdConf', res)
  } catch (error) {
    console.log(error)
  }
}
